export default __webpack_public_path__ + "static/media/logs-green.2f7458a3.svg";